"use client";

import Section from "../components/Section";
import { Suspense, useRef } from "react";

import Faqs, { FaqsRef } from "@/components/common/Faqs";
import { Box, Tab, TabList, Tabs, Typography } from "@repo/ui";
import { FaqType } from "@/graphql/queries/faqs-query";
import useFaqParams from "@/hooks/useFaqParams";
import Loading from "@/components/common/Loading";

type FrequentlyAskedQuestionsProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
    buttonText: string;
    buttonAction: string;
    faqs: {
      question: string;
      answer: string;
    }[];
  };
};
const FrequentlyAskedQuestions = ({
  data,
  sectionInfo,
}: FrequentlyAskedQuestionsProps) => {
  const { faqType } = useFaqParams();
  const faqsRef = useRef<FaqsRef>(null);

  const handleTabChange = (value: FaqType) => {
    faqsRef.current?.refetch({ faqType: value });
  };
  return (
    <Section id={sectionInfo.sectionId} className={sectionInfo.sectionClass}>
      <Box className="mb-10 flex justify-between items-center">
        <Typography variant="h2">{data.heading}</Typography>
        {faqType === FaqType.COURSES && (
          <Tabs defaultValue={faqType} onValueChange={handleTabChange}>
            <TabList name="frequently-asked-question-filter">
              <Tab value={FaqType.COURSES}>{`Course FAQ's`}</Tab>
              <Tab value={FaqType.PAYMENT}>{`Payment FAQ's`}</Tab>
            </TabList>
          </Tabs>
        )}
      </Box>
      <Suspense fallback={<Loading message="Loading FAQs..." />}>
        <Faqs ref={faqsRef} />
      </Suspense>
    </Section>
  );
};

export default FrequentlyAskedQuestions;
